import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { ParkingContractService } from '../data/parking-contract.service';

@Injectable()
export class PrintParkingContractFormCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: ParkingContractService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === leaseAgreementCommand.printParkingForm && command.context;
  }

  execute(command: Command): Observable<void> {
    return this._dataService.print(command.context.id).pipe(map(res => this._nativeWindow.openFile(res)));
  }
}
